var classes = {"featureCardContainer":"Z65-6","featureCardContentContainer":"q-L0C","featureCardOverlay":"F-7QD"};

export { classes as default };
